<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">支付数据开放</h1>

    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">支付数据开放</h4>
              </div>
              <!-- end panel-heading -->

              <!-- begin panel-body -->
              <div class="panel-body">
                <div style="height:60px;">
                  <a
                    class="btn btn-primary btn-sm ButtonColor PollingButton"
                    @click="PollingClick"
                  >开始轮询</a>
                  <a
                    class="btn btn-primary btn-sm ButtonColor PollingButton"
                    @click="PollingStop"
                  >停止轮询</a>
                </div>
                <div class="note note-secondary m-b-15">
                  <h4>
                    <b>{{Note}}</b>
                  </h4>
                  <!-- <textarea rows="30" cols="60" v-model="txt1"></textarea>
                 <textarea rows="30" cols="60" v-model="txt2"></textarea>
                  <div>
                      <button
                        class="swal-button swal-button--confirm btn btn-primary" 
                       
                  
                      > 请加签</button>
                  </div>-->
                </div>
              </div>
              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
  </div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import MethodsBus from "@/common/methodBus";
import eventBus from "@/common/eventBus";
// import EportClient from "@/common/client";

import { WSAEINVALIDPROVIDER } from 'constants';
export default {
  name: "OpenPay",
  data() {
    return {
      txt1: "",
      txt2: "",
      BrandOptions: [],
      Note: "暂无轮询",
      txt2:''
    };
  },

  mounted: function() {
    App.init();
  },
  methods: {
    PollingClick() {
      this.Note = "轮询中....";
      this.initdata();
      this.timeout = setInterval(() => {
        this.initdata();
      }, 600000);
    },


    SignDataAsPem(val,element,arr) {
      console.log(val);
      let that = this;
      window.EportClient.isInstalledTest(
        window.EportClient.cusSpcSignDataAsPEM,
        val,
        "168528ZC",
        function(msg, msgJson) {
          arr.push({
            orderNo: element.orderNo,
            signData: JSON.stringify(msg)
          })
          
          that.initdataSecond(arr);
        }
       
      ); 
    
    
    },
    initdataSecond(arr) {
      let that = this;
      const options = {
        url: "additionalSignature/getAddSignData",
        method: "post",
        headers: { "Content-Type": "application/json" },
        data:{
          signDatas:arr
        }
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
          }
        })
      
    },
    initdata() {
      let that = this;
      let arr = [];
      const options = {
        url: "additionalSignature/getAllWaiting",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({})
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            if (response.data.data.length !== 0) {
              that.BrandOptions = response.data.data;
              that.BrandOptions.forEach(element => {
                that.SignDataAsPem(element.beforeSignData,element,arr)
              
              });
           
            
             
            }
          } 
        })
      
    },
    PollingStop() {
      clearInterval(this.timeout);
      this.Note = "停止轮询";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ButtonColor {
  color: #fff !important;
}
.clear {
  clear: both;
}
.PollingButton {
  margin-top: 16px;
  float: left;
  margin-right: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/OpenPay.vue